import { Modal } from 'antd';
import ListOfBrokers, { BrokerSearchProps } from 'pages/Configuration/ManagementCompany/ListOfBrokers';
import React from 'react';
import { BrokerForProposalType } from './BrokerInput';

export type BrokerSearchModalProps = Pick<
BrokerSearchProps,
  'initialSearchParams' | 'onSelect'
> & {
  visible: boolean;
  onCancel: () => void;
  isProposalCreate: boolean;
  hideBrokerModal?: () => void;
  setBrokerForProposal?: (BrokerForProposal: BrokerForProposalType) => void;
};

const BrokerSearchModal = ({
  onCancel,
  visible,
  initialSearchParams,
  onSelect,
  isProposalCreate,
  hideBrokerModal,
  setBrokerForProposal,
}: BrokerSearchModalProps) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      width={1200}
      destroyOnClose
      footer={null}
    >
      <ListOfBrokers
        isModal="true"
        onSelect={onSelect}
        initialSearchParams={initialSearchParams}
        isProposalCreate={isProposalCreate}
        setBrokerForProposal={setBrokerForProposal}
        hideBrokerModal={hideBrokerModal}
      />
    </Modal>
  );
};

export default BrokerSearchModal;
